<template>
  <div class="tax-return-page">
    <dynamic-component-viewer
      class="dynamic-component"
      :component-name="componentName"
      :analytics-prefix="analyticsPrefix"
    />
  </div>
</template>

<script>

import DynamicComponentViewer from '@/components/DynamicComponentViewer.vue';
import consts from '@/store/utilities/constants';
import Segment from '@/Segment';
import BaseUI from '@riseupil/base-ui';
import { mapActions } from 'vuex';

export default {
  name: 'TaxReturnPage',
  components: {
    DynamicComponentViewer,
  },
  computed: {
    componentName: () => consts.DYNAMIC_COMPONENT_NAMES.TAX_RETURN,
    analyticsPrefix: () => 'TaxReturnPage',
  },
  created() {
    Segment.trackUserInteraction('TaxReturnPage_Entered');
    this.setAppHeaderProps({
      backgroundColorVariant: BaseUI.LayoutConsts.COLOR_VARIANT.LIGHT_GREEN,
    });
  },
  methods: {
    ...mapActions('appHeader', ['setAppHeaderProps']),
  },

};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";
@import "~@riseupil/base-ui/src/scss/spacings";

.tax-return-page {
  display: flex;
  height: 100%;
  flex-grow: 1;
  .dynamic-component {
    flex-grow: 1;
  }
}

</style>
